import { put, call, takeLatest } from 'redux-saga/effects';
import { dcrReportStateActions, fetchDcrReportDataCreator, fetchDcrDayReportDataCreator,fetchDailyPlanStatusDcrCreator } from './slice';
import { ToastType } from '@app/services/toaster';
import { NetworkService, ToasterService } from '@app/services';
import { API_PATH, HTTP_OK } from '@app/common/constants';
import { DCR_REPORT_FETCH_ERROR_MSG } from '@app/screens/module-specific-utilities/pages/dcr-report/redux/constants';
/**
 * Worker saga: Handles the main DCR Report list API call
 */
export function* fetchDcrReportWorker(action: any): any {
 
  const url = `${API_PATH.moduleSpecificUtilities.dcrreport.dcrreport}`;
  
  try {
    yield put(dcrReportStateActions.setDcrReportLoading());
    const response = yield call(NetworkService.post, url, action?.payload, {});
    // Handle error message from backend
    if (response?.data?.message && response.status === HTTP_OK) {
      ToasterService.showToaster(`${response.data.message}`, ToastType.ERROR);
      yield put(dcrReportStateActions.setDcrReportData({ row: [] }));
      yield put(dcrReportStateActions.setTableMessage(false));
    }
    // Handle successful response with result.value (new backend structure)
    else if (response.status === HTTP_OK && response?.data?.result?.value?.row) {
  const { row, totalCount } = response.data.result.value;
  yield put(dcrReportStateActions.setDcrReportData({ row, totalCount })); // <-- Store both!
  yield put(dcrReportStateActions.setTableMessage(true));
}
    // Handle successful response (legacy structure)
    else if (response.status === HTTP_OK && response?.data?.row) {
      yield put(dcrReportStateActions.setDcrReportData({ row: response.data.row }));
      yield put(dcrReportStateActions.setTableMessage(true));
    }
    // Handle other cases
    else {
      yield put(dcrReportStateActions.setDcrReportError());
      yield put(dcrReportStateActions.setTableMessage(false));
      ToasterService.showToaster(
        DCR_REPORT_FETCH_ERROR_MSG,
        ToastType.ERROR
      );
    }
  } catch (error) {
    yield put(dcrReportStateActions.setDcrReportError());
    yield put(dcrReportStateActions.setTableMessage(false));
   ToasterService.showToaster(
  DCR_REPORT_FETCH_ERROR_MSG,
  ToastType.ERROR
);
  }
}
export function* fetchDailyPlanStatusDcrWorker(action: any): any {

    const url = `${API_PATH.moduleSpecificUtilities.dcrreport.dailyplanstatusdcr}`;
  try {
    // Optionally set loading state here
    const response = yield call(NetworkService.get, url, action.payload, {});
    // Dispatch your success action here, e.g.:
    yield put(dcrReportStateActions.setCalendarResponse(response.data));
  } catch (error) {
    // Dispatch your error action here
    yield put(dcrReportStateActions.setCalendarError(error));
  }
}

/**
 * Worker saga: Handles the DCR Day Report API call
 */
export function* fetchDcrDayReportWorker(action: any): any {
  const url = `${API_PATH.moduleSpecificUtilities.approveExpense.dailyExpenseDcrReport}`;
  try {
    yield put(dcrReportStateActions.setDcrDayReportLoading());
    const response = yield call(NetworkService.post, url, action.payload);
    
    if (response.status === HTTP_OK && response?.data) {
      yield put(dcrReportStateActions.setDcrDayReportData(response.data));
    } else {
      yield put(dcrReportStateActions.setDcrDayReportError('Failed to fetch DCR report'));
    }
  } catch (error) {
    yield put(dcrReportStateActions.setDcrDayReportError('Error fetching DCR report'));
  }
  // REMOVED the finally block that was clearing the data!
}

/**
 * Root saga for DCR Reports
 */
export function* dcrReportSaga() {
 
  // Fixed: Swapped the workers to match their actual purpose
  yield takeLatest(fetchDcrReportDataCreator.type, fetchDcrReportWorker);
  yield takeLatest(fetchDcrDayReportDataCreator.type, fetchDcrDayReportWorker);
  yield takeLatest(fetchDailyPlanStatusDcrCreator.type, fetchDailyPlanStatusDcrWorker); 
}